import React from 'react';
import { IProps } from './types';

export const PrevNapLeft = ({ w, h, transform }: IProps) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      style={{
        background: '#00A651',
        transform: transform ? 'scale(-1, 1)' : '',
      }}
      width={w}
      height={h}
      viewBox="0 0 623.622 311.811"
    >
      <g id="Слой_1">
        <g id="XMLID_1_">
          <g>
            <rect id="XMLID_123_" x="97.224" y="72.374" fill="#FFFFFF" width="105.3" height="157.3" />
            <g id="XMLID_110_">
              <g id="XMLID_121_">
                <circle id="XMLID_122_" fill="#FFFFFF" cx="438.82" cy="100.06" r="20.947" />
              </g>
              <g id="XMLID_119_">
                <path
                  id="XMLID_120_"
                  fill="#FFFFFF"
                  d="M442.893,192.465l28.907-4.923c9.212-1.569,15.409-10.308,13.84-19.521l-7.573-44.476
						 c-1.492-8.759-9.801-14.65-18.56-13.159l-13.869,2.361c-8.759,1.492-14.65,9.801-13.159,18.56L442.893,192.465z"
                />
              </g>
              <g id="XMLID_117_">
                <path
                  id="XMLID_118_"
                  fill="#FFFFFF"
                  d="M451.607,249.122L451.607,249.122c3.677-2.251,4.834-7.057,2.583-10.735
						 l-14.519-23.728c-2.923-4.777-2.275-10.92,1.58-14.983l28.868-30.419l-11.326-10.746l-28.869,30.414
						 c-8.719,9.186-10.185,23.081-3.574,33.884l14.52,23.728C443.121,250.217,447.929,251.374,451.607,249.122z"
                />
              </g>
              <g id="XMLID_115_">
                <path
                  id="XMLID_116_"
                  fill="#FFFFFF"
                  d="M504.674,215.521c3.03,0,6.09-0.493,9.071-1.515l26.307-9.046
						 c4.079-1.402,6.249-5.846,4.847-9.925l0,0c-1.402-4.079-5.846-6.249-9.926-4.847l-26.306,9.045
						 c-5.281,1.84-11.163-0.147-14.286-4.783l-23.45-34.765l-12.947,8.733l23.449,34.765
						 C486.739,211.053,495.551,215.521,504.674,215.521z"
                />
              </g>
              <g id="XMLID_113_">
                <path
                  id="XMLID_114_"
                  fill="#FFFFFF"
                  d="M417.74,154.196c2.999,0,5.981-0.996,8.418-2.928l25.946-20.598
						 c3.378-2.679,3.942-7.594,1.26-10.97c-2.676-3.381-7.589-3.94-10.97-1.261l-24.893,19.759l-25.457-13.008
						 c-3.838-1.952-8.543-0.442-10.507,3.401c-1.962,3.843-0.44,8.545,3.401,10.507l26.655,13.618
						 C413.529,153.708,415.638,154.196,417.74,154.196z"
                />
              </g>
              <g id="XMLID_111_">
                <path
                  id="XMLID_112_"
                  fill="#FFFFFF"
                  d="M508.882,144.751c1.663,0,3.337-0.529,4.756-1.617
						 c3.419-2.633,4.056-7.534,1.429-10.95l-18.25-23.729c-3.225-4.189-8.631-6.11-13.768-4.936l-32.282,7.498
						 c-4.199,0.976-6.814,5.17-5.838,9.369c0.973,4.204,5.172,6.806,9.371,5.841l30.958-7.188l17.431,22.662
						 C504.226,143.704,506.542,144.751,508.882,144.751z"
                />
              </g>
            </g>
            <g id="XMLID_107_">
              <rect id="XMLID_109_" x="268.226" y="146.916" fill="#FFFFFF" width="96.854" height="46.8" />
              <path
                id="XMLID_108_"
                fill="#FFFFFF"
                d="M274.367,134.713v71.109c0,1.561-1.849,2.384-3.008,1.339l-41.261-37.164
					 c-0.819-0.738-0.79-2.031,0.061-2.731l41.261-33.945C272.596,132.354,274.367,133.19,274.367,134.713z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
